import React from 'react';
import { Step, Icon } from 'semantic-ui-react';

const RegisterStepper = (props) => {

    const {stepIndex} = props;

    return (
        <Step.Group vertical fluid>

        <Step active={(stepIndex === 1) ? true : false} completed={(stepIndex > 1) ? true : false}>
            <Icon name='book' />
            <Step.Content>
                <Step.Title>Terms and Conditions</Step.Title>
                <Step.Description>Agree to the terms and conditions</Step.Description>
            </Step.Content>
        </Step>

        <Step active={(stepIndex === 2) ? true : false} completed={(stepIndex > 2) ? true : false}>
            <Icon name='user secret' />
            <Step.Content>
                <Step.Title>Identification</Step.Title>
                <Step.Description>Let us know who you are</Step.Description>
            </Step.Content>
        </Step>

        <Step active={(stepIndex === 3) ? true : false} completed={(stepIndex > 3) ? true : false}>
            <Icon name='mail' />
            <Step.Content>
                <Step.Title>Email Address</Step.Title>
                <Step.Description>Let us know how to contact you</Step.Description>
            </Step.Content>
        </Step>

        <Step active={(stepIndex === 4) ? true : false} completed={(stepIndex > 4) ? true : false}>
            <Icon name='user plus' />
            <Step.Content>
                <Step.Title>One-Time Password</Step.Title>
                <Step.Description>Help us verify your email address</Step.Description>
            </Step.Content>
        </Step>

        <Step active={(stepIndex === 5) ? true : false} completed={(stepIndex > 5) ? true : false}>
            <Icon name='key' />
            <Step.Content>
                <Step.Title>Set Up Password</Step.Title>
                <Step.Description>Help us secure your account</Step.Description>
            </Step.Content>
        </Step>

        <Step active={(stepIndex === 6) ? true : false} completed={(stepIndex > 6) ? true : false}>
            <Icon name='edit' />
            <Step.Content>
                <Step.Title>Set Up Bank Details</Step.Title>
                <Step.Description>Set up your bank details</Step.Description>
            </Step.Content>
        </Step>

        <Step active={(stepIndex === 7) ? true : false} completed={(stepIndex > 7) ? true : false}>
            <Icon name='thumbs up' />
            <Step.Content>
                <Step.Title>Completed!</Step.Title>
                <Step.Description>Your account is ready</Step.Description>
            </Step.Content>
        </Step>

        </Step.Group>
    );
}

export default RegisterStepper;